// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Rana Process Types
 * Auto-generated input/output schemas for every Rana process tag. Do not edit manually.
 *
 * The version of the OpenAPI document: generated
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
import type { CalculateFloorLevelOutput } from "./CalculateFloorLevelOutput";
import {
  CalculateFloorLevelOutputFromJSON,
  CalculateFloorLevelOutputFromJSONTyped,
  CalculateFloorLevelOutputToJSON,
  CalculateFloorLevelOutputToJSONTyped,
} from "./CalculateFloorLevelOutput";
import type { CalculateFloorLevelInput } from "./CalculateFloorLevelInput";
import {
  CalculateFloorLevelInputFromJSON,
  CalculateFloorLevelInputFromJSONTyped,
  CalculateFloorLevelInputToJSON,
  CalculateFloorLevelInputToJSONTyped,
} from "./CalculateFloorLevelInput";

/**
 *
 * @export
 * @interface CalculateFloorLevelSchema
 */
export interface CalculateFloorLevelSchema {
  /**
   *
   */
  tag: CalculateFloorLevelSchemaTagEnum;
  /**
   *
   */
  inputs: CalculateFloorLevelInput;
  /**
   *
   */
  outputs: CalculateFloorLevelOutput;
}

/**
 * @export
 */
export const CalculateFloorLevelSchemaTagEnum = {
  CalculateFloorLevel: "calculate_floor_level",
} as const;
export type CalculateFloorLevelSchemaTagEnum =
  (typeof CalculateFloorLevelSchemaTagEnum)[keyof typeof CalculateFloorLevelSchemaTagEnum];

/**
 * Check if a given object implements the CalculateFloorLevelSchema interface.
 */
export function instanceOfCalculateFloorLevelSchema(
  value: object
): value is CalculateFloorLevelSchema {
  if (!("tag" in value) || value["tag"] === undefined) return false;
  if (value["tag"] !== "calculate_floor_level") return false;

  if (!("inputs" in value) || value["inputs"] === undefined) return false;
  if (!("outputs" in value) || value["outputs"] === undefined) return false;
  return true;
}

export function CalculateFloorLevelSchemaFromJSON(json: any): CalculateFloorLevelSchema {
  return CalculateFloorLevelSchemaFromJSONTyped(json, false);
}

export function CalculateFloorLevelSchemaFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): CalculateFloorLevelSchema {
  if (json == null) {
    return json;
  }
  return {
    tag: json["tag"],
    inputs: CalculateFloorLevelInputFromJSON(json["inputs"]),
    outputs: CalculateFloorLevelOutputFromJSON(json["outputs"]),
  };
}

export function CalculateFloorLevelSchemaToJSON(json: any): CalculateFloorLevelSchema {
  return CalculateFloorLevelSchemaToJSONTyped(json, false);
}

export function CalculateFloorLevelSchemaToJSONTyped(
  value?: CalculateFloorLevelSchema | null,
  ignoreDiscriminator: boolean = false
): any {
  if (value == null) {
    return value;
  }

  return {
    tag: value["tag"],
    inputs: CalculateFloorLevelInputToJSON(value["inputs"]),
    outputs: CalculateFloorLevelOutputToJSON(value["outputs"]),
  };
}
